import { RootState } from "@app/redux/root-reducer";

export const selectrequestState = (store: RootState) => store.requestReducer.getrequest;

export const selectAddrequestState = (store: RootState) =>
  store.requestReducer.addrequest;

export const selectDeleterequestState = (store: RootState) =>
  store.requestReducer.deleterequest;

export const selectRequestDetailState = (store: RootState) =>
  store.requestReducer.requestDetail;